import { render, staticRenderFns } from "./yian-detail.vue?vue&type=template&id=06303aeb&scoped=true&"
import script from "./yian-detail.vue?vue&type=script&lang=ts&"
export * from "./yian-detail.vue?vue&type=script&lang=ts&"
import style0 from "./yian-detail.vue?vue&type=style&index=0&id=06303aeb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06303aeb",
  null
  
)

export default component.exports